import { catalogPresets } from './catalogPresets';

const getPresetSectionIdForActivity = (activityId) => {
  switch (activityId) {
    case 'electrician':
      return 'electrician';
    case 'plumber':
      return 'plumber';
    case 'construction':
      return 'btp';
    case 'freelance':
      return 'freelance';
    case 'beauty':
      return 'beauty';
    case 'other':
    default:
      return 'services';
  }
};

const calcTotals = ({ quantity, unitPrice, discount = 0, vatRate }) => {
  let subtotal = Number(quantity || 0) * Number(unitPrice || 0);
  if (discount && discount > 0) {
    subtotal = subtotal * (1 - Number(discount) / 100);
  }
  const totalHT = subtotal;
  const totalTTC = totalHT * (1 + Number(vatRate || 0) / 100);
  return { totalHT, totalTTC };
};

const pickPresetItems = (activityId, count = 3) => {
  const sectionId = getPresetSectionIdForActivity(activityId);
  const section = (catalogPresets || []).find((s) => s.id === sectionId);
  if (!section?.items?.length) return [];
  return section.items.slice(0, Math.max(1, count));
};

export const getDefaultQuoteItemsForActivity = (activityId, { defaultVatRate = 20, globalVatZero = false } = {}) => {
  if (!activityId) return [];
  const presets = pickPresetItems(activityId, 3);
  if (!presets.length) return [];

  return presets.map((preset) => {
    const vatRate = globalVatZero ? 0 : (preset.vatRate ?? defaultVatRate);
    const base = {
      id: Date.now() + Math.random(),
      description: preset.description || preset.label,
      reference: '',
      quantity: preset.quantity || 1,
      unit: preset.unit || 'unité',
      unitPrice: preset.unitPrice || 0,
      discount: 0,
      vatRate,
      totalHT: 0,
      totalTTC: 0,
      deliveryDate: '',
    };

    const totals = calcTotals(base);
    return { ...base, ...totals };
  });
};

export const getDefaultInvoiceItemsForActivity = (activityId, { defaultVatRate = 20, globalVatZero = false } = {}) => {
  if (!activityId) return [];
  const presets = pickPresetItems(activityId, 3);
  if (!presets.length) return [];

  return presets.map((preset) => {
    const vatRate = globalVatZero ? 0 : (preset.vatRate ?? defaultVatRate);
    const base = {
      id: Date.now() + Math.random(),
      description: preset.description || preset.label,
      quantity: preset.quantity || 1,
      unit: preset.unit || 'unité',
      unitPrice: preset.unitPrice || 0,
      discount: 0,
      vatRate,
      totalHT: 0,
      totalTTC: 0,
    };

    const totals = calcTotals(base);
    return { ...base, ...totals };
  });
};
